import { render, staticRenderFns } from "./ProductSingle.vue?vue&type=template&id=2920882f&scoped=true&lang=pug"
import script from "./ProductSingle.vue?vue&type=script&lang=js"
export * from "./ProductSingle.vue?vue&type=script&lang=js"
import style0 from "./ProductSingle.vue?vue&type=style&index=0&id=2920882f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2920882f",
  null
  
)

export default component.exports